import { addDays, format } from "date-fns";
import { excelDateToJSDate } from "../../../utils/helpers/files/exceldatetojs";

const regexEmail =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function formatDate(date) {
  try {
    return format(addDays(new Date(date), 1), "MM-dd-yyyy");
  } catch (error) {
    return undefined;
  }
}

function formatTime(time) {
  try {
    return format(excelDateToJSDate(time), "HH:mm");
  } catch (error) {
    return undefined;
  }
}

function emailValidate(email) {
  try {
    const emailValid = regexEmail.test(email);
    return emailValid ? email : undefined;
  } catch (error) {
    return undefined;
  }
}

export function allExcelColumns(row, index) {
  const formatedRow = {
    index,
    login: emailValidate(row.login),
    company: row.company,
    origin: row.origin,
    destination: row.destination,
    boardingdate: formatDate(row.boardingdate),
    boardingtill: formatTime(row.boardingtill),
    arrivaldate: formatDate(row.arrivaldate),
    arrivaltime: formatTime(row.arrivaltime),
    locator: row.locator ? row.locator : "",
    terminal: row.terminal ? row.terminal : "",
    seat: row.seat ? row.seat : "",
    boardinggroup: row.boardinggroup ? row.boardinggroup : "",
    extrainformation: row.extrainformation ? row.extrainformation : "",
  };

  return formatedRow;
}

export function findRowsWithError(validRows) {
  validRows.map((e) => {
    if (!e.arrivaldate) {
      delete e.arrivaldate;
      delete e.arrivaltime;
    }
    return e;
  });
  const rowsWithError = validRows.filter(
    (row) =>
      Object.values(row).filter((value) => value === undefined).length > 0
  );

  return rowsWithError;
}

export async function getUnregisteredEmails(rows, participants) {
  var allUsersInEvent = participants ? participants : [];

  const unregisteredEmails = [];

  rows.map((e) => {
    if (e.participants) {
      const users = e.participants.replaceAll(" ", "").split(",");

      users.map((user) => {
        const search = allUsersInEvent.find(
          (userSearch) => userSearch.email === user
        );

        if (
          !search &&
          !unregisteredEmails.find((email) => email.index === e.index)
        ) {
          unregisteredEmails.push({
            ...e,
            participants: undefined,
          });
        }

        const searchDuplicity = users.filter(
          (userFilter) => userFilter === user
        );

        if (
          searchDuplicity.length > 1 &&
          !unregisteredEmails.find((email) => email.index === e.index)
        ) {
          unregisteredEmails.push({
            ...e,
            participants: undefined,
          });
        }
      });
    }
  });

  return unregisteredEmails;
}

export async function getInvalidsIds(rows, allVehicles) {
  var invalidsIds = [];

  rows.map((row) => {
    const search = allVehicles.find((part) => part.id === row.id);

    if (!search)
      invalidsIds.push({
        ...row,
        id: undefined,
      });
  });

  return invalidsIds;
}

export async function validCapacity(rows) {

  var invalidCapacities = [];

  rows.map((row) => {
    const capacity = Number(row.seatingCapacity);
    const participants = row.participants.replaceAll(" ", "").split(",");

    if (participants.length > capacity) {
      invalidCapacities.push({
        ...row,
        seatingCapacity: undefined,
      });
    }
  });

  return invalidCapacities;
}
